import React, { lazy, Suspense } from 'react';
import { PwaInstallProvider } from './hooks/usePwaInstall';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import './globals.css';
import './styles/admin-typography.css';
import './styles/form-controls.css';
import PromotionViewPage from './pages/PromotionViewPage';
import NotFound from './pages/NotFound';
import { isPublicPromotionRoute } from './theme/themePreference';
import ErrorBoundary from './components/common/ErrorBoundary';
import { Toaster } from './components/ui/toaster';
const AdminApp = lazy(() => import('./AdminApp'));

function App() {
  return (
    <ErrorBoundary>
      <PwaInstallProvider><Router>
        <RouteBoundary />
      </Router></PwaInstallProvider>
    </ErrorBoundary>
  );
}

export function RouteBoundary() {
  const { pathname } = useLocation();
  if (isPublicPromotionRoute(pathname)) return <>
    <Routes><Route path="/:identifier" element={<PromotionViewPage key={pathname} />} /><Route path="*" element={<NotFound />} /></Routes>
    <Toaster />
  </>;
  return <Suspense fallback={<div className="promotion-page-state" role="status">화면을 불러오고 있습니다.</div>}><AdminApp pathname={pathname} /></Suspense>;
}

export default App;
